export default __webpack_public_path__ + "static/article2-83ca1cf4c68455c599cd2fda5faf3292.png";